import { FiasRoomType, GarHouseAddType, GarHouseType } from '@skbkontur/react-ui-addons';
import { countryInfoRussia } from '../../constants/constants';
export const defaultEmployeeAddress = {
    country: { name: countryInfoRussia.fullName, code: countryInfoRussia.code },
    text: countryInfoRussia.fullName,
};
export const fiasFieldsSettings = {
    region: { visible: true, validation: false },
    district: { visible: true, validation: false },
    municipaldistrict: { visible: false },
    city: { visible: true, validation: false },
    intracityarea: { visible: true, validation: false },
    urbansettlement: { visible: false },
    settlement: { visible: true, validation: false },
    planningstructure: { visible: true, validation: false },
    street: { visible: true, validation: false },
    stead: { visible: false },
    house: { visible: false },
    garhouse: { visible: true, validation: false },
    room: { visible: true, validation: false },
    apartment: { visible: false },
    postalcode: { visible: true },
};
export const garHouseInfoFieldsInSS = [
    {
        typeFieldName: 'houseType',
        numberFieldName: 'houseNum',
        possibleTypeValues: Object.values(GarHouseType),
    },
    {
        typeFieldName: 'addType1',
        numberFieldName: 'addNum1',
        possibleTypeValues: Object.values(GarHouseAddType),
    },
    {
        typeFieldName: 'addType2',
        numberFieldName: 'addNum2',
        possibleTypeValues: Object.values(GarHouseAddType),
    },
];
export const roomTypes = {
    [FiasRoomType.None]: '',
    [FiasRoomType.Room]: 'комната',
    [FiasRoomType.Placement]: 'помещение',
};
export const flatTypes = {
    0: '',
    1: 'помещение',
    2: 'квартира',
    3: 'офис',
    4: 'комната',
    5: 'рабочий участок',
    6: 'склад',
    7: 'торговый зал',
    8: 'цех',
    9: 'павильон',
    10: 'подвал',
    11: 'котельная',
    12: 'погреб',
    13: 'гараж',
    14: 'машино-место',
};
export const houseAbbriviations = {
    none: '',
    hold: 'владение',
    house: 'дом',
    houseHold: 'домовладение',
    garage: 'гараж',
    building: 'здание',
    mine: 'шахта',
    structure: 'строение',
    construction: 'сооружение',
    litera: 'литера',
    housing: 'корпус',
    basement: 'подвал',
    boilerRoom: 'котельная',
    cellar: 'погреб',
    unfinishedConstruction: 'объект нез-го стр-ва',
};
export const houseTypes = [
    'none',
    'hold',
    'house',
    'houseHold',
    'garage',
    'building',
    'mine',
    'structure',
    'construction',
    'litera',
    'housing',
    'basement',
    'boilerRoom',
    'cellar',
    'unfinishedConstruction',
];
